export default function (community) {
  return {
    test: [
      {
        active: true,
        kind: "micro-fll",
        title: "Etapa Micro-FLL",
        description:
          "Participe de torneios da FLL em etapas seletivas não-oficiais.",
        level: 1,
      },
      {
        active: true,
        kind: "seletiva",
        title: "Etapa Seletiva",
        description:
          "Participe de torneios da FLL em etapas seletivas não-oficiais.",
        level: 1,
      },
      {
        active: true,
        kind: "regional",
        title: "Etapa Regional",
        description:
          "Inscreva-se nos regionais oficiais do Torneio de Robótica FLL",
        level: 2,
      },
      {
        active: true,
        kind: "nacional",
        title: "Etapa Nacional",
        description:
          "Inscreva-se no Torneio Nacional da FLL, apenas para equipes classificadas em uma etapa regional.",
        level: 3,
      },
    ],
    "fll-brasil": [
      {
        active: true,
        kind: "micro-fll",
        title: "Etapa Micro-FLL",
        description:
          "Participe de torneios da FLL em etapas seletivas não-oficiais.",
        level: "1",
      },
      {
        active: true,
        kind: "seletiva",
        title: "Etapa Seletiva",
        description:
          "Participe de torneios da FLL em etapas seletivas não-oficiais.",
        level: "1",
      },
      {
        active: true,
        kind: "regional",
        title: "Etapa Regional",
        description:
          "Inscreva-se nos regionais oficiais do Torneio de Robótica FLL",
        level: "2",
      },
      {
        active: true,
        kind: "nacional",
        title: "Etapa Nacional",
        description:
          "Inscreva-se no Torneio Nacional da FLL, apenas para equipes classificadas em uma etapa regional.",
        level: "3",
      },
    ],
    "ftc-brasil": [
      {
        active: true,
        kind: "off_season",
        title: "Off Season",
        description: "Participe de torneios da FTC for.",
        level: "1",
      },
      {
        active: false,
        kind: "seletiva",
        title: "Etapa Seletiva",
        description:
          "Participe de torneios da FTC em etapas seletivas não-oficiais.",
        level: "1",
      },
      {
        active: true,
        kind: "regional",
        title: "Etapa Regional",
        description: "Inscreva-se nos regionais oficiais do Torneio da FTC.",
        level: "2",
      },
      {
        active: true,
        kind: "nacional",
        title: "Etapa Nacional",
        description: "Inscreva-se no Torneio Nacional da FTC",
        level: "3",
      },
    ],
    "frc-brasil": [
      {
        active: true,
        kind: "seletiva",
        title: "Off season",
        description: "Inscreva-se no Torneio Off Season da FRC",
        level: "1",
      },
      {
        active: true,
        kind: "regional",
        title: "Etapa Regional",
        description: "Inscreva-se nos regionais oficiais do Torneio da FRC.",
        level: "2",
      },
      {
        active: true,
        kind: "nacional",
        title: "Etapa Nacional",
        description: "Inscreva-se nos nacionais oficiais do Torneio da FRC.",
        level: "3",
      },
    ],
    "f1-brasil": [
      {
        active: true,
        kind: "off_season",
        title: "Off Season",
        description: "Participe de Torneios Off Season da F1 in Schools.",
        level: "1",
      },
      {
        active: true,
        kind: "regional",
        title: "Etapa Regional",
        description:
          "Inscreva-se nos regionais oficiais do Torneio da F1 in Schools",
        level: "2",
      },
      {
        active: true,
        kind: "nacional",
        title: "Etapa Nacional",
        description: "Inscreva-se no Torneio Nacional da F1 in Schools",
        level: "3",
      },
    ],
    desafiocovid: [
      {
        active: true,
        kind: "regional",
        title: "Etapa - Fase 1",
        description: "Inscreva-se no Desafio SESI de Robótica COVID-19",
        level: 1,
      },
      {
        active: false,
        kind: "nacional",
        title: "Etapa - Fase 2",
        description: "Inscreva-se no Desafio SESI de Robótica COVID-19",
        level: 2,
      },
    ],
    desafiorelampago: [
      {
        active: true,
        kind: "regional",
        title: "Etapa - Desenvolvimento de propostas",
        description: "Inscreva-se no Desafio Relâmpago - Volta às Aulas",
        level: 1,
      },
      {
        active: false,
        kind: "nacional",
        title: "Etapa - Entrevistas On-line",
        description: "Inscreva-se no Desafio Relâmpago - Volta às Aulas",
        level: 2,
      },
    ],
    "fll-open-brazil": [
      {
        active: true,
        kind: "internacional",
        title: "Etapa Internacional",
        description: "Inscreva-se no FLL Open Brasil",
        level: 2,
      },
    ],
    "off-season-sesi-mt": [
      {
        active: true,
        kind: "off_season",
        title: "Etapa Off Season",
        description: "Inscreva-se no Torneio Off Season SESI MT",
        level: 1,
      },
    ],
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getPossibleStages.js